import { render } from "./RecordsIntro.vue?vue&type=template&id=eb1442e4"
import script from "./RecordsIntro.vue?vue&type=script&lang=js"
export * from "./RecordsIntro.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/aft/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__